import React from 'react';
import './RSVPGuestsModal.scss';
import { on } from 'events';

/**
 * @param {{ isOpen: boolean; onClose: () => void; attendees: { id: string; imageUrl: string; alt: string }[] }} props
 */
const RSVPGuestsModal = ({ isOpen, onClose, attendees, onRSVP }) => {
  if (!isOpen) return null;

  // Find center index: priority to a valid imageUrl
  const validIndex = attendees.findIndex(u => u.imageUrl && u.imageUrl.trim() !== '');
  const centerIndex = validIndex >= 0 ? validIndex : Math.floor(attendees.length / 2);

  // Determine slice window of 5 attendees around center
  const total = attendees.length;
  let start = centerIndex - 2;
  if (start < 0) start = 0;
  let end = start + 5;
  if (end > total) {
    end = total;
    start = Math.max(0, total - 5);
  }
  const slice = attendees.slice(start, end);

  // Generate a consistent color per user ID
  const getRandomColor = (id) => {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
      hash = id.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 50%)`;
  };

  // Get initial letter from alt (assumed name)
  const getInitial = (alt) => (alt ? alt.charAt(0).toUpperCase() : '');

  return (
    <div className="rsvp-guests-modal-overlay">
      <div className="rsvp-guests-modal">
        <button className="close-button" onClick={onClose} aria-label="Close">
          ×
        </button>
        <div className="avatars-row">
          {slice.map((user, idx) => {
            const isCenter = idx === 2;
            const classes = ['guest-avatar', isCenter ? 'center' : 'edge'];
            const hasImage = user.imageUrl && user.imageUrl.trim() !== '';
            return hasImage ? (
              <img
                key={user.id}
                src={user.imageUrl}
                alt={user.name}
                className={classes.join(' ')}
              />
            ) : (
              <div
                key={user.id}
                className={classes.join(' ')}
                style={{ backgroundColor: getRandomColor(user.uid) }}
              >
                <span className="initial">{getInitial(user.name)}</span>
              </div>
            );
          })}
        </div>
        <h3 className="rsvp-title">RSVP to view more guests!</h3>
        <button className="rsvp-button" onClick={onRSVP}>
          RSVP
        </button>
      </div>
    </div>
  );
};

export default RSVPGuestsModal;
